import React from "react";
import { DarkMode } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import PublicNavbar from "../components/Navbar/PublicNavbar";
import Footer from "../components/Footer/Footer";

const PublicLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const hideFooter = pathname === "/" || pathname === "/login";

  return (
    <DarkMode>
      {children}
      {!hideFooter && <Footer />}
    </DarkMode>
  );
};

export default PublicLayout;
